import React, { useEffect, useState } from "react";
import localizationService from "../../services/localization-service.js";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const SmsNoThanksModal = ({ isOpen, onClose }) => {
  const selectedlang = useSelector((state) => state.account.lang);
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);
  const location = useLocation();
  const isTextMessagesPage = location.pathname === "/textMessages";

  useEffect(() => {
    if (window.innerWidth < 1300) {
      setIsDesktopResolution(false);
    }
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="px-6 py-3" style={{ position: "relative" }}>
          <i
            className="fas fa-times absolute right-2 top-2 cursor-pointer text-gray-600 hover:text-black"
            onClick={onClose}
          ></i>
        </div>
        <div className="px-6 py-4">
          <p className="text-sm text-gray-500 mb-3">
            {localizationService.getLocalizationValue(
              "notToSubscribe",
              selectedlang,
            )}
            <a
              href={!isTextMessagesPage ? "/textMessages" : undefined}
              className="text-messages-link"
              style={{
                pointerEvents: isTextMessagesPage ? "none" : "auto",
                color: isTextMessagesPage ? "#6b7280" : "#9aa82d",
              }}
            >
              {localizationService.getLocalizationValue(
                "textMessages",
                selectedlang,
              )}
            </a>
            {localizationService.getLocalizationValue("tab", selectedlang)}
          </p>
        </div>
        <div className="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-center space-x-3">
          <button
            onClick={onClose}
            className={`inline-flex items-center justify-center ${!isDesktopResolution ? "w-[100%]" : "w-[70%]"} px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-[#ffffff] hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200`}
          >
            {localizationService.getLocalizationValue("close", selectedlang)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SmsNoThanksModal;
